export default class LedgerAccount {
    public ledgerAccountId: number = 0;
    public name: string = '';
    public accountNumber: string = '';

    constructor(obj: any = {}) {
        Object.assign(this, obj);
    }
}
